export enum JoinSpecificTeamFields {
  TEAM_NAME = 'teamName',
  PASSWORD = 'password',
}
